import { useMutation, useQueryClient } from "@tanstack/vue-query";

import { useServices } from "@/configuration/plugins/app/app-provider.configuration";
import { InternalMutationKeys } from "@/data/api/kili/internal/internal-query-keys";
import { SitesQueryKeys } from "@/data/api/kili/sites/sites-query-keys";
import { mapSubprogramsDto } from "@/data/api/v4b/program/subprogram.mapping";
import { ProgramId, V4HSiteId } from "@/data/common/ids";
import { SubprogramsByApplianceCategory } from "@/domains/v4b/program/subprogram.types";

export type TEditSiteProgramCommand = {
  siteId: V4HSiteId;
  programId: ProgramId;
  subPrograms: SubprogramsByApplianceCategory;
};

export function useUpdateSiteProgramSubprogramsMutation() {
  const v4bClientSdk = useServices().v4b.clientSdk;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: InternalMutationKeys.editSiteProgram(),
    mutationFn: async ({ programId, subPrograms }: TEditSiteProgramCommand) => {
      await v4bClientSdk.siteProgram.updateSubprograms(programId, mapSubprogramsDto(subPrograms));
    },
    onSettled: (_data, _error, command) => {
      queryClient.invalidateQueries({
        queryKey: SitesQueryKeys.programDetails(command.siteId, command.programId),
      });
    },
    retry: false,
  });
}
